module.exports = __webpack_public_path__ + "80e123e99017bcb0f1e018dacdc1289f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/theme-files/image-resources/blurred-img/blurred-img-1.jpg
// module id = 400
// module chunks = 0